import React from 'react';
import { classNames } from '../../../utils/style';
import { container } from '../../../styles/themes';

import { getClientBanner } from './logic';
import { ClientBanner } from './ClientBanner';
import { ClientContent, ClientContentProps } from './ClientContent';
import { ClientVideo, ClientVideoProps } from './ClientVideo';
import { ClientWithoutVideo } from './ClientWithoutVideo';
import { ImageProps } from '../../../components/Image/types';

export interface ClientProps extends ClientVideoProps, ClientContentProps {
  collectiveAgreement?: string;
  collectiveAgreementLabel?: string;
  clientSize?: string;
  clientSizeLabel?: string;
  sectorLabel?: string;
  sector?: string;
  location?: string;
  onClickVideoThumbnail?: any;
  locationLabel?: string;
  classnameThumbnail?: string;
  classnameThumbclassnameBoxThumbnailnail?: string;
}
export interface ClientHeroProps extends ClientProps {
  image: ImageProps;
}

export const ClientHero = ({
  VideoPlayer,
  image,
  logo,
  collectiveAgreement,
  collectiveAgreementLabel,
  clientSize,
  clientSizeLabel,
  sectorLabel,
  sector,
  location,
  locationLabel,
  contentTitle,
  children,
  onClickVideoThumbnail,
  classnameThumbnail,
  classnameBoxThumbnail,
}: ClientHeroProps) => {
  const clientBanner = getClientBanner(
    collectiveAgreement,
    collectiveAgreementLabel,
    clientSize,
    clientSizeLabel,
    sectorLabel,
    sector,
    location,
    locationLabel,
  );

  return (
    <div className="relative flex flex-col client-banner">
      <div className={classNames('bg-blue-21', 'mt-[100px]', 'md:mt-[150px]')}>
        <div
          className={classNames(
            container,
            'z-10 pt-40 mb-48 lg:w-8/12 lg:pb-64',
            'mt-[-100px]',
            'md:mt-[-150px]',
          )}
        >
          {VideoPlayer ? (
            <ClientVideo
              VideoPlayer={VideoPlayer}
              logo={logo}
              image={image}
              onClickVideoThumbnail={onClickVideoThumbnail}
              classnameThumbnail={classnameThumbnail}
              classnameBoxThumbnail={classnameBoxThumbnail}
            />
          ) : (
            <ClientWithoutVideo
              logo={logo}
              image={image}
              classnameThumbnail={classnameThumbnail}
              classnameBoxThumbnail={classnameBoxThumbnail}
            />
          )}
        </div>
        <ClientBanner clientBanner={clientBanner as any} />
        <ClientContent contentTitle={contentTitle}>{children}</ClientContent>
      </div>
    </div>
  );
};
